import { render, staticRenderFns } from "./scoreOrNotSet.vue?vue&type=template&id=92807dbe&scoped=true&"
import script from "./scoreOrNotSet.vue?vue&type=script&lang=js&"
export * from "./scoreOrNotSet.vue?vue&type=script&lang=js&"
import style0 from "./scoreOrNotSet.vue?vue&type=style&index=0&id=92807dbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92807dbe",
  null
  
)

export default component.exports